import { computed, makeObservable } from 'mobx';
import { Team } from '.';
import { StoreNode } from '../store';
import { Store } from '../store/store';

type Props = {
  teamId: string,
  cursor: string,
  index: number
}

/** Stores a pointer to a Team in a catalog list and the pagination info associated with it. */
export class TeamCatalogItem
  extends StoreNode {

  constructor(store: Store, props?: Props) {
    super(store, props);
    makeObservable(this, {
      team: computed,
    });
    Object.assign(this, props);
  }

  readonly teamId!: string;
  readonly cursor!: string;
  readonly index!: number;

  get team(): Team {
    return this.store.teamManager.strictGetAdminTeam(this.teamId);
  }
}